import { render, staticRenderFns } from "./seo.vue?vue&type=template&id=0d7a4de6&"
import script from "./seo.vue?vue&type=script&lang=js&"
export * from "./seo.vue?vue&type=script&lang=js&"
import style0 from "./seo.vue?vue&type=style&index=0&id=0d7a4de6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports